import { QuoteApiModel, QuoteOptionApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SumNumber, onlyUnique } from '../../lib/helpers/ArrayHelper';
import { ProtectionExtraIds } from '../ExtrasHelper';

export function generateProtectionKey(extras: { Id: string }[]) {
  return `ID:${extras
    .map((x) => x.Id)
    .filter(onlyUnique)
    .filter((x) => ProtectionExtraIds.includes(x))
    .sort()
    .join('|')}`;
}

export function generateProtectionPercentageKey(percentage: number) {
  return `${percentage}`;
}

export function getSelectedQuoteOption(item: SmartSendItemApiModel, quote: QuoteApiModel): QuoteOptionApiModel {
  return quote.Options.find((o) => generateProtectionKey(o.Extras) === generateProtectionKey(item.Extras));
}

export interface CalculatedTotal {
  TotalPrice: number;
  Duties: number;
  TotalPriceExVat: number;
  TotalVat: number;
  VatRate: number;
}

export function getCalculatedTotal(qo: QuoteOptionApiModel): CalculatedTotal {
  if (!qo) {
    return {
      Duties: 0,
      TotalPrice: 0,
      TotalPriceExVat: 0,
      TotalVat: 0,
      VatRate: 0
    };
  }

  const o: CalculatedTotal = {
    TotalPrice: qo.TotalPrice,
    TotalPriceExVat: qo.TotalPriceExVat,
    TotalVat: qo.TotalVat,
    VatRate: qo.VatRate,
    Duties: 0
  };

  if (qo.ManualCalculations) {
    const vat = SumNumber(qo.ManualCalculations.map((x) => x.Vat));
    o.TotalVat += vat;
    o.TotalPrice += vat;

    const duties = SumNumber(qo.ManualCalculations.map((x) => x.Duties ?? 0));
    o.Duties += duties;
    o.TotalPrice += duties;

    const price = SumNumber(qo.ManualCalculations.map((x) => x.Price));
    o.TotalPriceExVat += price;
    o.TotalPrice += price;
  }

  return o;
}
